import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpUtils} from "../shared/http.utils";
import {EncoderFilters} from "../model/filters/encoder-filters";
import {DefaultEncoderFilters} from "../model/filters/default-encoder-filters";
import {DefaultEncoderPersistRequest} from "../model/requests/default-encoder-persist-request";

@Injectable({
  providedIn: 'root'
})
export class DefaultEncodersService {

  private readonly defaultEncodersURL: string;

  constructor(private http: HttpClient) {
    this.defaultEncodersURL = "/catalog/default_encoders";
  }

  public getDefaultEncoders(offset?: number, limit?: number, filters?: DefaultEncoderFilters): Observable<any> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new EncoderFilters();
    return this.http.post<any>(this.defaultEncodersURL, body, options);
  }

  public getDefaultEncoder(name: string): Observable<any> {
    const url = `${this.defaultEncodersURL}/${name}`;
    return this.http.get<any>(url);
  }

  public createDefaultEncoder(defaultEncoderCreationData: DefaultEncoderPersistRequest) {
    let url = `${this.defaultEncodersURL}/create`;
    return this.http.post<any>(url, defaultEncoderCreationData);
  }

  public editDefaultEncoder(defaultEncoderEditionData: DefaultEncoderPersistRequest) {
    let url = `${this.defaultEncodersURL}/edit`;
    return this.http.post<any>(url, defaultEncoderEditionData);
  }

  public deleteDefaultEncoder(name: string): Observable<HttpResponse<any>> {
    const url = `${this.defaultEncodersURL}/${name}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteDefaultEncoders(names: string[]) {
    let url = `${this.defaultEncodersURL}/delete`;
    return this.http.post<any>(url, names, {observe: 'response'});
  }

}
